export default __webpack_public_path__ + "static/media/layout-3.13d2cdc7.jpg";